import React, { useState } from "react";
import * as Icons from "lucide-react";
import { ChevronDown } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { UI, t } from "@/i18n/translations";
import { ASTUCES } from "@/data/content";

export default function Astuces() {
  const { lang } = useLang();
  const A = UI.astuces;
  const [open, setOpen] = useState(0);

  return (
    <div className="animate-fade-up space-y-5">
      <div>
        <h1 className="font-display text-3xl font-extrabold tracking-tight">{t(A.title, lang)}</h1>
        <p className="text-sm text-ink/60 mt-1">{t(A.intro, lang)}</p>
      </div>

      <div className="space-y-3">
        {ASTUCES.map((panel, i) => {
          const Icon = Icons[panel.icon] || Icons.Lightbulb;
          const isOpen = open === i;
          const tips = panel.tips[lang] || panel.tips.fr;
          return (
            <div key={i} className="rounded-[18px] bg-white border border-line overflow-hidden shadow-sm">
              <button
                data-testid={`astuce-header-${i}`}
                onClick={() => setOpen(isOpen ? -1 : i)}
                className="w-full flex items-center gap-3 px-4 py-4 text-left"
              >
                <span className={`grid place-items-center w-9 h-9 rounded-xl transition-colors ${isOpen ? "bg-amber/20" : "bg-paper"}`}>
                  <Icon className="w-5 h-5 text-amber" strokeWidth={2.2} />
                </span>
                <span className="flex-1 font-display text-base font-bold leading-tight">{t(panel.title, lang)}</span>
                <ChevronDown className={`w-5 h-5 text-ink/40 transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`} />
              </button>
              <div
                className="grid transition-all duration-300 ease-out"
                style={{ gridTemplateRows: isOpen ? "1fr" : "0fr" }}
              >
                <div className="overflow-hidden">
                  <ul className="px-4 pb-4 pt-0 space-y-2.5">
                    {tips.map((tip, j) => (
                      <li key={j} className="flex gap-2.5 text-[14px] text-ink/75 leading-relaxed">
                        <span className="mt-1.5 shrink-0 w-1.5 h-1.5 rounded-full bg-sage" />
                        {tip}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
